<template>
  <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="800px" lock-scroll :destroy-on-close="true" append-to-body :before-close="cancel">
    <div class="div-el-class">
      <el-form label-width="120px" ref="form" :model="form" :rules="rules">
        <el-form-item label="合同扫描文件" label-width="150px" v-if="form.contractScanningFlag" prop="contractScanningFile">
          <div style="display: flex; align-items: center; width: 100%;">
            <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false"
                       :on-change="(...event)=>{handleChange(event,'contract')}"
                       :on-remove="(...event)=>{handleRemove(event,'contract')}"
                       :file-list="contractFileList" :on-exceed="handleExceed">
              <el-input v-model="contractFileName" readonly style="width: 250px;"></el-input>
              <el-button type="primary" size="small" style="margin-left: 10px;">选择文件</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="结题报告扫描文件" v-if="form.reportScanningFlag" label-width="150px" prop="reportScanningFile">
          <div style="display: flex; align-items: center; width: 100%;">
            <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false"
                       :on-change="(...event)=>{handleChange(event,'report')}"
                       :on-remove="(...event)=>{handleRemove(event,'report')}"
                       :file-list="reportFileList" :on-exceed="handleExceed">
              <el-input v-model="reportFileName" readonly style="width: 250px;"></el-input>
              <el-button type="primary" size="small" style="margin-left: 10px;">选择文件</el-button>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="报账资料扫描文件" v-if="form.reimbursementScanningFlag" label-width="150px" prop="reimbursementScanningFile">
          <div style="display: flex; align-items: center; width: 100%;">
            <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false"
                       :on-change="(...event)=>{handleChange(event,'reimbursement')}"
                       :on-remove="(...event)=>{handleRemove(event,'reimbursement')}"
                       :file-list="reimbursementFileList" :on-exceed="handleExceed">
              <el-input v-model="reimbursementFileName" readonly style="width: 250px;"></el-input>
              <el-button type="primary" size="small" style="margin-left: 10px;">选择文件</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" class="title" @click="cancel">取消</el-button>
      <el-button size="small" class="title" @click="handle" type="primary">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>


import {uploadScanning} from "@/api/dilivery/mail";

export default {
  name: "UploadScanning",
  props:['showDialog','selectDetail'],
  data(){
    return{
      title:'上传扫描件',
      contractFileName:'',
      reportFileName:'',
      reimbursementFileName:'',
      contractFileList:[],
      reportFileList:[],
      reimbursementFileList:[],
      form:{
        id:'',
        contractScanningFlag:false,
        reportScanningFlag:false,
        reimbursementScanningFlag:false,
        contractScanningFile: null,
        reportScanningFile: null,
        reimbursementScanningFile:null
      },
      rules:{
        contractScanningFile:[
          {required: true, message: '请上传合同扫描文件', trigger: 'change'},
        ],
        reportScanningFile:[
          {required: true, message: '请上传结题报告扫描文件', trigger: 'change'},
        ],
        reimbursementScanningFile:[
          {required: true, message: '请上传报账资料扫描文件', trigger: 'change'},
        ]
      }
    }
  },
  watch:{
    selectDetail:{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          this.form.contractScanningFlag = newVal.mailingContent.contractScanningFlag
          this.form.reportScanningFlag = newVal.mailingContent.reportScanningFlag
          this.form.reimbursementScanningFlag = newVal.mailingContent.reimbursementScanningFlag
        }
      },
      immediate:true
    },
  },
  mounted() {
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    },
    handleExceed(files) {
      this.$messageUi.error('只能上传一个文件，请先移除已有文件再上传'); // 超出数量时提醒
    },
    handleChange(file,type) {
      switch (type){
        case 'contract':
          this.form.contractScanningFile = file[0]
          this.contractFileList = [file[0]]
          this.contractFileName = file[0].name
          break;
        case 'report':
          this.form.reportScanningFile = file[0]
          this.reportFileList = [file[0]]
          this.reportFileName = file[0].name
          break;
        case 'reimbursement':
          this.form.reimbursementScanningFile = file[0]
          this.reimbursementFileList = [file[0]]
          this.reimbursementFileName = file[0].name
          break;
        default:
          break
      }
    },
    handleRemove(file,type) {
      switch (type){
        case 'contract':
          this.form.contractScanningFile = null
          this.contractFileList = []
          this.contractFileName = ''
          break;
        case 'report':
          this.form.reportScanningFile = null
          this.reportFileList = []
          this.reportFileName = ''
          break;
        case 'reimbursement':
          this.form.reimbursementScanningFile = null
          this.reimbursementFileList = []
          this.reimbursementFileName = ''
          break;
        default:
          break
      }
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          const list = ['contractScanningFile','reportScanningFile','reimbursementScanningFile']
          const formData = new FormData();
          for(let key of list){
            if(this.form[key]){
              formData.append(key, this.form[key].raw);
            }
          }
          formData.append('id', this.form.id);
          uploadScanning(formData).then(res => {
            if (res.code === 200) {
              this.$emit('submit','confirm')
              this.$messageUi.success('提交成功')
            }
          }).catch(err => {
          })
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  },
}
</script>

<style scoped>

</style>
